/**
 * Five EDGE intro routes — written verbatim from Michael's spec.
 * Each one is a single-screen framing page that stays in The Edge
 * world before sending the user into the deeper tool experience.
 */

import React from "react";
import EdgeIntroScreen from "./EdgeIntroScreen";

export function LivingVisionIntro() {
  return (
    <EdgeIntroScreen
      testId="edge-intro-living-vision"
      title="Living Vision"
      sub="See it. Feel it. Become it."
      body={[
        "This is where you create a clear picture of where you're going and set this as your living reality.",
        "Not just something you look at\u2014",
        "Something you feel.",
        "A living vision that keeps you aligned, focused, and moving forward.",
        "Return to it daily. Let it guide your decisions.",
      ]}
      ctaLabel="Create Your Vision"
      ctaTo="/networker/performance-vision/setup"
    />
  );
}

export function BankOfReclaimIntro() {
  return (
    <EdgeIntroScreen
      testId="edge-intro-bank-of-reclaim"
      title="Bank of Reclaim"
      sub="Normalise wealth. Expand your capacity."
      body={[
        "This is where you begin to feel comfortable with larger numbers.",
        "To see them. To hold them. To experience them without tension.",
        "Because what feels normal\u2026 becomes natural.",
        "And what becomes natural\u2026 begins to show up in your reality.",
      ]}
      ctaLabel="Enter Your Bank"
      ctaTo="/bank-of-reclaim"
    />
  );
}

export function StateResetsIntro() {
  return (
    <EdgeIntroScreen
      testId="edge-intro-state-resets"
      title="State Resets"
      sub="Shift your state in real time."
      body={[
        "These are tools for the moments that matter.",
        "Before a call. After a setback. When your focus drops.",
        "Simple resets that bring you back to clarity, calm, and control.",
        "Use them often.",
      ]}
      ctaLabel="Choose a Reset"
      ctaTo="/networker/resets"
    />
  );
}

export function PrivateSuiteIntro() {
  return (
    <EdgeIntroScreen
      testId="edge-intro-private-suite"
      title="Private Suite"
      sub="Your personal space for deep installation."
      body={[
        "This is where everything comes together.",
        "Your voice. Your identity. Your state.",
        "Create personalised audio experiences that guide your mind into the version of you you are becoming.",
        "Built around you. For you.",
      ]}
      ctaLabel="Enter Your Suite"
      ctaTo="/private-suite"
    />
  );
}

export function GuidedPerformanceIntro() {
  return (
    <EdgeIntroScreen
      testId="edge-intro-guided-performance"
      title="Guided Performance"
      sub="State. Identity. Momentum."
      body={[
        "These are guided experiences designed to shift how you feel and how you show up.",
        "Use them to prepare, reset, expand, integrate.",
        "This is where you build consistency.",
      ]}
      ctaLabel="Start a Session"
      ctaTo="/networker/audio-library"
    />
  );
}
